import React, { useEffect, useState } from 'react';
import useRouter from '../../../utils/useRouter';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import CourseFinishPageSuccess from './CourseFinishPageSuccess';
import CourseFinishPageProgress from './CourseFinishPageProgress';
import { cardDimensionsMedia, spaces } from '../../../assets/styles/themes/tokens';
import CourseFinishPageLoader from './CourseFinishPageLoader';
import { selectUser } from '../../../reducers/user.selectors';
import courseService from '../../../services/course.service';
import { CourseRegistration } from '@kimuno/api-sdk/lib/types/responses/CourseRegistration';

const CourseFinishPage = () => {
  const { match } = useRouter();
  const user = useSelector(selectUser);
  const [isFetching, setIsFetching] = useState(true);
  const [updatedCourseRegistration, setUpdatedCourseRegistration] =
    useState<CourseRegistration | null>(null);
  const scormCourseId = match.params.scormCourseId;

  useEffect(() => {
    if (scormCourseId && user) {
      courseService
        .getUpdatedCourseRegistration(user.id, scormCourseId)
        .then((courseRegistration) => {
          setUpdatedCourseRegistration(courseRegistration);
          window.top?.postMessage({
            eventType: 'courseRegistration',
            courseRegistration,
          }, '*');
        })
        .finally(() => setIsFetching(false));
    }
  }, [scormCourseId, user]);

  const renderContent = () => {
    if (isFetching) {
      return <CourseFinishPageLoader />;
    }

    if (updatedCourseRegistration?.isCompleted && updatedCourseRegistration?.isPassed) {
      return (
        <CourseFinishPageSuccess courseRegistration={updatedCourseRegistration} />
      );
    }

    return <CourseFinishPageProgress />;
  };

  return (
    <Box sx={{ height: '100vh' }}>
      <Box
        sx={{
          maxWidth: cardDimensionsMedia.desktop.maxWidth,
          width: '100%',
          height: '100%',
          marginX: 'auto',
          paddingX: spaces.md,
        }}
      >
        {renderContent()}
      </Box>
    </Box>
  );
};

export default CourseFinishPage;
